/**
 * trim.js — сокращение ВНУТРИ предложения: то, чего в этом туле не было.
 *
 * ПОЧЕМУ ЭТОГО НЕ ХВАТАЛО. Выбор предложений (rank.js) отвечает на «сожми
 * статью вчетверо». Но запрос за словами «сократить текст» чаще другой и куда
 * более узкий: текст УЖЕ почти влезает — 172 знака при лимите 155, 2180 слов
 * при 2000 — и надо снять последние 10%. Выбор предложений на этом промежутке
 * не инструмент, а топор: чтобы убрать 17 знаков, он выбрасывает целую фразу
 * (часто вывод — вывод редко «централен» по словам) и промахивается мимо цели
 * в другую сторону, причём молча.
 *
 * ЧТО ДЕЛАЕТ ЭТОТ ФАЙЛ. Ищет места, которые можно снять или заменить КОРОЧЕ,
 * не трогая смысла: усилители («очень»), вводные («стоит отметить, что»),
 * многословные служебные обороты («в связи с тем, что» → «поскольку»),
 * плеоназмы («в конечном итоге» → «в итоге»), вставки в скобках. Каждое место —
 * операция с позицией, классом и выигрышем; наружу отдаётся СПИСОК операций, а
 * не готовый текст: показать и отменить можно только то, что названо поимённо.
 *
 * ПОРЯДОК — ПО ЦЕНЕ СМЫСЛА, А НЕ ПО ВЫИГРЫШУ. Ярусы: замена служебного оборота
 * не теряет ничего (0), снятие усилителя теряет нажим (1), снятие вводного —
 * позицию автора (2), снятие вставки — пояснение (3), снятие предложения —
 * утверждение (4). Берём снизу вверх и ОСТАНАВЛИВАЕМСЯ, как только цель
 * достигнута: если 17 знаков набрались на трёх «очень», больше ничего не
 * тронуто. Это и есть разница между «уложить в лимит» и «сжать как получится».
 *
 * ЧЕГО ЗДЕСЬ НЕТ И ПОЧЕМУ. Залог и отглагольные существительные не трогаются:
 * «осуществляется контроль» → «контролируют» требует морфологии (словарь в
 * мегабайты), без неё правило ломает согласование. Пары из тире («— вот так —»)
 * тоже нет: тире в русском ещё и связка («Москва — столица»), и правило, не
 * умеющее их различить, режет сказуемое.
 *
 * Exposed as window.TSTrim.
 */
(function (root) {
    'use strict';
    if (root.TSTrim) return;

    /* Ярус = сколько смысла стоит операция. Применяем по возрастанию. */
    var TIER = { wordy: 0, filler: 1, hedge: 2, aside: 3, sent: 4 };

    /* ──────────────────────────────────────────────────────────────────
       ПРАВИЛА
       wordy  — замена: оборот на короткий синоним той же служебной роли;
                падеж и управление сохранены, поэтому замена безопасна.
       filler — снятие усилителя: наречие степени, его удаление не меняет
                ни согласования, ни управления никогда.
       hedge  — снятие вводного: обособлено запятыми, снимается вместе с ними.
       ────────────────────────────────────────────────────────────────── */
    var RULES = {
        ru: {
            /* Третий элемент = 1: замена — ПРОСТОЙ союз, и запятая, которая
               в составном обороте стояла внутри («в связи с тем, что»), должна
               встать ПЕРЕД ним («работу перенесли, поскольку…»). Без этого
               флага правило выдаёт «перенесли поскольку сроки» — грамотный
               текст, сокращённый безграмотно, и это видно сразу. */
            wordy: [
                ['в связи с тем,? что', 'поскольку', 1],
                ['по причине того,? что', 'поскольку', 1],
                ['в силу того,? что', 'поскольку', 1],
                ['ввиду того,? что', 'поскольку', 1],
                ['несмотря на то,? что', 'хотя', 1],
                ['невзирая на то,? что', 'хотя', 1],
                ['для того,? чтобы', 'чтобы', 1],
                ['с тем,? чтобы', 'чтобы', 1],
                ['в том случае,? если', 'если', 1],
                ['в случае,? если', 'если', 1],
                ['при условии,? что', 'если', 1],
                ['в то время,? как', 'пока', 1],
                ['тот факт,? что', 'что', 1],
                ['в настоящее время', 'сейчас'],
                ['в данный момент', 'сейчас'],
                ['на данный момент', 'сейчас'],
                ['на сегодняшний день', 'сегодня'],
                ['в течение длительного времени', 'долго'],
                ['на протяжении длительного времени', 'долго'],
                ['в непосредственной близости', 'рядом'],
                ['большое количество', 'много'],
                ['значительное количество', 'много'],
                ['огромное количество', 'множество'],
                ['в целях', 'для'],
                ['с целью', 'для'],
                ['по отношению к', 'к'],
                ['в конечном итоге', 'в итоге'],
                ['в конечном счёте', 'в итоге'],
                ['в конечном счете', 'в итоге'],
                ['и тому подобное', 'и т. п.'],
                ['и так далее', 'и т. д.'],
                ['является причиной', 'вызывает'],
                ['оказывает влияние на', 'влияет на'],
                ['оказывают влияние на', 'влияют на'],
                ['имеет возможность', 'может'],
                ['имеют возможность', 'могут'],
                ['период времени', 'период'],
                ['промежуток времени', 'промежуток'],
                ['свободная вакансия', 'вакансия'],
                ['прейскурант цен', 'прейскурант'],
                ['памятный сувенир', 'сувенир'],
                ['внутренний интерьер', 'интерьер'],
                ['первый дебют', 'дебют'],
                ['главный приоритет', 'приоритет'],
                ['окончательный итог', 'итог'],
                ['совместное сотрудничество', 'сотрудничество'],
                ['основной лейтмотив', 'лейтмотив'],
                ['возвращаться обратно', 'возвращаться'],
                ['подниматься вверх', 'подниматься'],
                ['спускаться вниз', 'спускаться'],
            ],
            /* Здесь нет «буквально» и «исключительно»: оба несут смысл, а не
               нажим («буквально переводится», «исключительно для членов»), и
               их снятие меняет утверждение, а не его громкость. Нет и
               «довольно»/«достаточно» — это смягчители: без них фраза
               становится СИЛЬНЕЕ оригинала, что тоже правка смысла. */
            filler: [
                /* «реально» здесь нет: «реально существует» — утверждение, а
                   не нажим. «действительно ли» — вопрос, слово в нём несёт смысл. */
                'очень', 'весьма', 'крайне', 'чрезвычайно', 'поистине',
                'действительно(?!\\s+ли(?![\\p{L}]))', 'совершенно', 'абсолютно', 'напрочь',
                'категорически', 'предельно', 'воистину', 'по-настоящему',
            ],
            hedge: [
                'конечно', 'разумеется', 'безусловно', 'естественно', 'бесспорно',
                'несомненно', 'по сути', 'по существу', 'в сущности', 'фактически',
                'собственно', 'на самом деле', 'в самом деле', 'как известно',
                'как правило', 'как видим', 'как показывает практика',
                'стоит отметить,? что', 'следует отметить,? что',
                'необходимо отметить,? что', 'важно отметить,? что',
                'хочется отметить,? что', 'нужно сказать,? что', 'надо сказать,? что',
                'следует подчеркнуть,? что', 'стоит подчеркнуть,? что',
                'отметим,? что', 'заметим,? что', 'подчеркнём,? что', 'подчеркнем,? что',
                'кстати', 'между прочим', 'к слову', 'впрочем', 'в общем', 'в целом',
                'в принципе', 'так или иначе', 'таким образом', 'итак', 'при этом',
                'в свою очередь', 'более того', 'кроме того', 'помимо этого',
                'вместе с тем', 'а именно', 'как уже (?:было )?сказано выше',
                'как отмечалось выше', 'на наш взгляд', 'по нашему мнению',
                'по моему мнению', 'на мой взгляд', 'как нам кажется',
            ],
        },
        en: {
            wordy: [
                ['in order to', 'to'],
                ['for the purpose of', 'for'],
                ['due to the fact that', 'because'],
                ['owing to the fact that', 'because'],
                ['on account of the fact that', 'because'],
                ['in spite of the fact that', 'although'],
                ['despite the fact that', 'although'],
                ['in the event that', 'if'],
                ['on the grounds that', 'because'],
                ['at this point in time', 'now'],
                ['at the present time', 'now'],
                ['in the near future', 'soon'],
                ['a large number of', 'many'],
                ['a great number of', 'many'],
                ['the majority of', 'most'],
                ['a majority of', 'most'],
                ['a small number of', 'few'],
                ['prior to', 'before'],
                ['subsequent to', 'after'],
                ['with regard to', 'about'],
                ['with respect to', 'about'],
                ['in relation to', 'about'],
                ['in reference to', 'about'],
                ['has the ability to', 'can'],
                ['have the ability to', 'can'],
                ['is able to', 'can'],
                ['are able to', 'can'],
                ['make a decision', 'decide'],
                ['reach a decision', 'decide'],
                ['give consideration to', 'consider'],
                ['take into consideration', 'consider'],
                ['in the majority of cases', 'usually'],
                ['in a timely manner', 'promptly'],
                ['on a regular basis', 'regularly'],
                ['in close proximity to', 'near'],
                ['each and every', 'every'],
                ['first and foremost', 'first'],
                ['end result', 'result'],
                ['final outcome', 'outcome'],
                ['past history', 'history'],
                ['past experience', 'experience'],
                ['free gift', 'gift'],
                ['advance planning', 'planning'],
                ['basic fundamentals', 'fundamentals'],
                ['unexpected surprise', 'surprise'],
                ['added bonus', 'bonus'],
                ['absolutely essential', 'essential'],
                ['completely eliminate', 'eliminate'],
                ['may possibly', 'may'],
                ['brief summary', 'summary'],
                ['new innovation', 'innovation'],
                ['revert back', 'revert'],
                ['repeat again', 'repeat'],
                ['combine together', 'combine'],
                ['join together', 'join'],
                ['plan ahead', 'plan'],
                ['true fact', 'fact'],
                ['personal opinion', 'opinion'],
                ['general consensus', 'consensus'],
                ['future plans', 'plans'],
                ['sum total', 'total'],
                ['is going to', 'will'],
                ['are going to', 'will'],
            ],
            /* «just» здесь нет: «just one» без него — другое утверждение. */
            filler: [
                /* «very much» — устойчивое: «thank you much» не по-английски. */
                'very(?!\\s+much(?![\\p{L}]))', 'really', 'actually', 'basically', 'literally', 'truly',
                'extremely', 'incredibly', 'absolutely', 'completely', 'totally',
                'virtually', 'definitely', 'certainly', 'particularly', 'simply',
            ],
            hedge: [
                'of course', 'needless to say', 'as a matter of fact', 'in fact',
                'it is important to note that', 'it should be noted that',
                'it is worth noting that', 'it is interesting to note that',
                'as we all know', 'as you know', 'in my opinion', 'in my view',
                'generally speaking', 'for all intents and purposes',
                'at the end of the day', 'obviously', 'clearly', 'arguably',
                'essentially', 'indeed', 'moreover', 'furthermore', 'in addition',
                'that being said', 'having said that', 'to be honest',
                /* Смягчители идут сюда, а не в усилители: «somewhat effective»
                   без них становится СИЛЬНЕЕ оригинала, и это тоже правка
                   смысла — только в другую сторону, поэтому и ярус дороже. */
                /* «rather than» — союз (без «rather» остаётся «compounds than
                   water»), «quite a few» — «много», а не «немного». */
                'quite(?!\\s+a\\s+(?:few|bit|lot|while)(?![\\p{L}]))', 'rather(?!\\s+than(?![\\p{L}]))', 'fairly', 'somewhat',
            ],
        },
        /* Для остальных языков — только безопасное БЕЗ морфологии: наречие
           степени снимается, не задевая согласования, ни в одном из них, а
           перечисленные обороты проверяемо служебные. Утверждать «работает для
           всех» дороже, чем работать для тех, где правила проверены: выбор
           предложений и вставки в скобках языконезависимы и работают везде. */
        de: {
            wordy: [['aufgrund der Tatsache, dass', 'weil'], ['zum jetzigen Zeitpunkt', 'jetzt'], ['eine große Anzahl von', 'viele'], ['zu dem Zweck', 'um']],
            filler: ['sehr', 'wirklich', 'ziemlich', 'ausgesprochen', 'überaus', 'durchaus', 'völlig', 'absolut'],
            hedge: ['natürlich', 'selbstverständlich', 'im Grunde', 'im Großen und Ganzen', 'meiner Meinung nach', 'bekanntlich'],
        },
        es: {
            wordy: [['debido al hecho de que', 'porque'], ['en el momento actual', 'ahora'], ['un gran número de', 'muchos'], ['con el fin de', 'para'], ['a pesar del hecho de que', 'aunque'], ['la mayor parte de', 'casi todo']],
            filler: ['muy', 'realmente', 'bastante', 'sumamente', 'completamente', 'absolutamente', 'totalmente', 'verdaderamente'],
            hedge: ['por supuesto', 'evidentemente', 'obviamente', 'en realidad', 'en general', 'en mi opinión', 'cabe señalar que'],
        },
        fr: {
            wordy: [['en raison du fait que', 'parce que'], ['un grand nombre de', 'beaucoup de'], ['dans le but de', 'pour'], ['malgré le fait que', 'bien que'], ['la plupart des', 'presque tous les']],
            filler: ['très', 'vraiment', 'assez', 'extrêmement', 'complètement', 'absolument', 'totalement', 'particulièrement'],
            hedge: ['bien sûr', 'évidemment', 'en réalité', 'en général', 'à mon avis', 'il convient de noter que', 'il faut noter que'],
        },
        pt: {
            wordy: [['devido ao facto de que', 'porque'], ['devido ao fato de que', 'porque'], ['no momento atual', 'agora'], ['um grande número de', 'muitos'], ['com o objetivo de', 'para'], ['apesar do facto de que', 'embora']],
            filler: ['muito', 'realmente', 'bastante', 'extremamente', 'completamente', 'absolutamente', 'totalmente', 'verdadeiramente'],
            hedge: ['claro', 'evidentemente', 'obviamente', 'na verdade', 'em geral', 'na minha opinião', 'vale notar que'],
        },
        id: {
            wordy: [['dengan tujuan untuk', 'untuk'], ['pada saat ini', 'sekarang'], ['sejumlah besar', 'banyak'], ['disebabkan oleh fakta bahwa', 'karena']],
            filler: ['sangat', 'benar-benar', 'cukup', 'amat', 'sungguh', 'sepenuhnya'],
            hedge: ['tentu saja', 'pada dasarnya', 'secara umum', 'menurut saya', 'perlu dicatat bahwa'],
        },
        /* Украинский — тем же принципом, что русский, но короче: только обороты,
           у которых замена сохраняет управление («велика кількість витрат» →
           «багато витрат», оба с родительным). «З метою» сюда НЕ взят: перед
           инфинитивом («з метою зменшити») замена на «для» даёт «для
           зменшити». Апостроф пишется и прямым, и типографским — оба варианта
           в шаблоне. До 2026-10-02 украинский текст получал только скобки и
           выбор предложений. */
        uk: {
            wordy: [
                ['у зв(?:\'|’)язку з тим,? що', 'оскільки', 1],
                ['в зв(?:\'|’)язку з тим,? що', 'оскільки', 1],
                ['для того,? щоб', 'щоб', 1],
                ['з тим,? щоб', 'щоб', 1],
                ['незважаючи на те,? що', 'хоча', 1],
                ['попри те,? що', 'хоча', 1],
                ['у (?:тому )?випадку,? якщо', 'якщо', 1],
                ['в (?:тому )?випадку,? якщо', 'якщо', 1],
                ['за умови,? що', 'якщо', 1],
                ['на даний момент', 'зараз'],
                ['в даний час', 'зараз'],
                ['у даний час', 'зараз'],
                ['на сьогоднішній день', 'сьогодні'],
                ['протягом тривалого часу', 'довго'],
                ['впродовж тривалого часу', 'довго'],
                ['велика кількість', 'багато'],
                ['значна кількість', 'багато'],
                ['у кінцевому підсумку', 'зрештою'],
                ['в кінцевому підсумку', 'зрештою'],
                ['і так далі', 'і т. д.'],
                ['і тому подібне', 'і т. п.'],
                ['має можливість', 'може'],
                ['мають можливість', 'можуть'],
                ['період часу', 'період'],
                ['проміжок часу', 'проміжок'],
                ['вільна вакансія', 'вакансія'],
                ['пам(?:\'|’)ятний сувенір', 'сувенір'],
                ['головний пріоритет', 'пріоритет'],
                ['спільна співпраця', 'співпраця'],
                ['повертатися назад', 'повертатися'],
                ['підніматися вгору', 'підніматися'],
                ['спускатися вниз', 'спускатися'],
            ],
            filler: [
                'дуже', 'вкрай', 'надзвичайно', 'абсолютно', 'цілковито', 'дійсно',
                'справді', 'неймовірно', 'страшенно', 'по-справжньому',
            ],
            hedge: [
                'звичайно', 'звісно', 'безумовно', 'безперечно', 'по суті', 'фактично',
                'власне', 'насправді', 'як відомо', 'як правило', 'як бачимо',
                'як показує практика', 'варто зазначити,? що', 'слід зазначити,? що',
                'необхідно зазначити,? що', 'важливо зазначити,? що',
                'варто відзначити,? що', 'слід підкреслити,? що', 'варто підкреслити,? що',
                'зазначимо,? що', 'до речі', 'між іншим', 'втім', 'загалом',
                'в цілому', 'у цілому', 'в принципі', 'так чи інакше', 'таким чином',
                'при цьому', 'у свою чергу', 'більше того', 'крім того', 'окрім того',
                'разом з тим', 'як уже (?:було )?сказано вище', 'на наш погляд',
                'на нашу думку', 'на мою думку', 'на мій погляд', 'як нам здається',
            ],
        },
    };

    /* ──────────────────────────────────────────────────────────────────
       ЯЗЫК ТЕКСТА, А НЕ СТРАНИЦЫ.

       До 2026-10-02 правила выбирались по локали страницы: английский текст,
       вставленный на /ru/, проверялся русскими оборотами, не находил ничего и
       сразу уходил в выбор предложений — тот самый топор, от которого этот
       файл и защищает. Язык определяется по письменности, а внутри латиницы —
       по служебным словам: ровно те слова, что в любом тексте встречаются
       десятками, и ровно те, что у соседних языков разные. Общие для
       испанского, французского и португальского «de», «la», «que» в счёт не
       идут намеренно — они голосуют за всех троих сразу.
       ────────────────────────────────────────────────────────────────── */
    var LATIN_VOTES = {
        en: 'the|and|of|to|is|that|with|for|this|are|was|it|be|have|on|not|you|which|from|they',
        de: 'der|die|und|das|ist|nicht|mit|ein|eine|den|von|zu|sich|auch|für|dem|auf|ich|wird|werden',
        es: 'el|los|las|y|un|una|por|para|con|es|del|como|pero|más|este|esta|son|lo|al|muy',
        fr: 'le|les|et|des|est|une|un|du|pour|dans|pas|qui|sur|avec|ce|sont|au|aux|cette|mais',
        pt: 'os|um|uma|não|para|com|é|do|da|em|por|mais|dos|das|são|como|mas|ao|na|no',
        id: 'yang|dan|di|ini|itu|dengan|untuk|dari|tidak|ada|akan|dalam|juga|pada|ke|kami|bisa|atau|karena|saya',
    };
    var VOTE_SETS = {};
    Object.keys(LATIN_VOTES).forEach(function (k) {
        VOTE_SETS[k] = {};
        LATIN_VOTES[k].split('|').forEach(function (w) { VOTE_SETS[k][w] = 1; });
    });

    function countMatches(s, re) { var m = s.match(re); return m ? m.length : 0; }

    /**
     * detectLang(text, fallback) → 'ru' | 'uk' | 'en' | 'de' | 'es' | 'fr' |
     * 'pt' | 'id' | 'ko' | 'ar' | fallback.
     * Смотрит первые 6000 знаков: дальше ответ уже не меняется, а длинную
     * главу незачем считать целиком на каждом нажатии.
     */
    function detectLang(text, fallback) {
        var s = String(text || '').slice(0, 6000);
        var fb = String(fallback || 'en').slice(0, 2).toLowerCase();
        var cyr = countMatches(s, /[Ѐ-ӿ]/g);
        var lat = countMatches(s, /[A-Za-zÀ-ɏ]/g);
        var han = countMatches(s, /[가-힯ᄀ-ᇿ㄰-㆏]/g);
        var arb = countMatches(s, /[؀-ۿݐ-ݿ]/g);
        var top = Math.max(cyr, lat, han, arb);
        if (!top) return fb;
        if (top === han) return 'ko';
        if (top === arb) return 'ar';
        if (top === cyr) {
            /* Украинский или русский — общий определитель сайта (timbrica-core):
               служебные слова и окончания, а не только буквы і/ї/є/ґ против
               ы/э/ъ/ё (украинская фраза без этих букв уходила в ничью). Ничья —
               язык страницы; кириллица другого языка — русские правила. */
            var cl = root.__cyrillicLang;
            var cy = typeof cl === 'function' ? cl(s, { fallback: fb === 'uk' ? 'uk' : 'ru' }) : (fb === 'uk' ? 'uk' : 'ru');
            return cy === 'uk' ? 'uk' : 'ru';
        }
        var words = s.toLowerCase().match(/[a-zà-öø-ÿ]+/g) || [];
        var best = null, bestN = 0;
        Object.keys(VOTE_SETS).forEach(function (k) {
            var n = 0, set = VOTE_SETS[k];
            for (var i = 0; i < words.length; i++) if (set[words[i]]) n++;
            if (n > bestN) { best = k; bestN = n; }
        });
        if (best) return best;
        return VOTE_SETS[fb] ? fb : 'en';
    }

    /* Подчинительный союз в начале предложения означает, что левая запятая перед
       вводным принадлежит придаточному, а не вводному, и снимать её нельзя:
       «Когда всё готово, конечно, можно начинать» → «Когда всё готово, можно
       начинать», а не «…готово можно…». */
    /* Граница слова здесь — НЕ `\b`: он определён через ASCII-`\w`, поэтому
       «Когда» кириллицей `\b` не заканчивает, проверка молча возвращает false,
       и запятая придаточного уезжает вместе с вводным («Когда всё готово,
       конечно, можно» → «Когда всё готово можно»). Нужен явный юникодный
       lookahead и флаг `u`. */
    var SUBORD = new RegExp('^\\s*(?:после того как|прежде чем|потому что|так как|несмотря на то что|когда|если|пока|хотя|поскольку|чтобы|что|котор\\p{L}+|раз|'
        + 'після того як|перш ніж|тому що|оскільки|коли|якщо|поки|хоча|щоб|що|котр\\p{L}+|бо|'
        + 'although|because|since|while|when|if|after|before|unless|though|whereas)(?![\\p{L}\\p{N}-])', 'iu');

    var LETTER = /\p{L}/u;
    /* Отрицание прямо перед словом (с пробелом между ними). */
    var NEGATION = /(?:^|[^\p{L}])(?:не|ни|not|never|no|nicht|kein|nie|pas|jamais|não|nao|nunca|tidak|bukan|ні)[ \t ]+$|n['’]t[ \t ]+$/iu;

    function esc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

    /* Термин может быть готовым фрагментом регэкспа («стоит отметить,? что») —
       экранировать его целиком нельзя, иначе `,?` станет литералом. Признак —
       метасимволы, которых в обычном слове не бывает. */
    function pat(term) { return /[?()|\\]/.test(term) ? term : esc(term); }

    // ── защищённые участки ───────────────────────────────────────────────

    /**
     * Куда правило не заходит НИКОГДА: кавычки (цитата — чужие слова),
     * ссылки, почта, хэштеги и @упоминания. Это внешние обязательства текста,
     * а не его многословие.
     */
    function guards(text) {
        var out = [];
        /* „…“ — немецкие и украинские кавычки: до 2026-10-02 их не было, и
           цитата в немецком тексте правилась как обычная фраза. */
        [/«[^»]*»/g, /"[^"\n]{0,400}"/g, /“[^”]*”/g, /„[^“”\n]{0,400}[“”]/g,
            /https?:\/\/\S+/g, /www\.\S+/g, /\S+@\S+\.\S+/g,
            /[@#][\p{L}\p{N}_]+/gu,
        ].forEach(function (re) {
            var m;
            re.lastIndex = 0;
            while ((m = re.exec(text))) {
                out.push([m.index, m.index + m[0].length]);
                if (m.index === re.lastIndex) re.lastIndex++;
            }
        });
        return out;
    }

    function guarded(zones, s, e) {
        for (var i = 0; i < zones.length; i++) {
            if (s < zones[i][1] && e > zones[i][0]) return true;
        }
        return false;
    }

    // ── границы удаления ─────────────────────────────────────────────────

    /**
     * Вводное обособлено запятыми, и снимать его надо ВМЕСТЕ с ними — иначе
     * остаётся висячая запятая, по которой машинная правка узнаётся с первого
     * взгляда. Возвращает {s, e, cap}: cap — надо ли поднять регистр следующей
     * буквы (вводное стояло в начале предложения).
     */
    function hedgeSpan(text, s, e, sentStart) {
        var after = text.slice(e, e + 24);
        var before = text.slice(Math.max(0, s - 24), s);
        var atStart = s <= sentStart + 1;
        var mA = /^[ \t]*,/.exec(after);           // «конечно, дальше» — запятая без хвоста
        var mB = /,[ \t]+$/.exec(before);          // «дальше, конечно»
        var ds = s, de = e, cap = false;

        if (mA && mB && !atStart) {
            de = e + mA[0].length;
            if (!SUBORD.test(text.slice(sentStart, s))) ds = s - mB[0].length;
        } else if (mA) {
            de = e + mA[0].length;
            cap = atStart;
        } else if (mB) {
            ds = s - mB[0].length;                 // «…, конечно.» → «….»
        } else if (/^[ \t]/.test(after)) {
            de = e + 1;
            cap = atStart;
        } else if (/[ \t]$/.test(before)) {
            ds = s - 1;
        }
        return { s: ds, e: de, cap: cap };
    }

    /** Усилитель — одиночное наречие: снимается вместе с одним пробелом. */
    function fillerSpan(text, s, e, sentStart) {
        if (/^[ \t]/.test(text.slice(e, e + 1))) return { s: s, e: e + 1, cap: s <= sentStart + 1 };
        if (/[ \t]$/.test(text.slice(Math.max(0, s - 1), s))) return { s: s - 1, e: e, cap: false };
        return { s: s, e: e, cap: false };
    }

    // ── поиск операций ───────────────────────────────────────────────────

    function langOf(lang) {
        var k = String(lang || 'ru').slice(0, 2).toLowerCase();
        return RULES[k] || null;
    }

    /**
     * ops(text, opts) → [{s, e, rep, cls, tier, cap}]
     *
     * opts.lang      — язык правил; без набора остаются только языконезависимые
     *                  операции (вставки в скобках).
     * opts.sentences — результат TSRank.split: нужен, чтобы отличить начало
     *                  предложения (регистр) от середины.
     */
    function ops(text, opts) {
        opts = opts || {};
        var src = String(text || '');
        var zones = guards(src);
        var found = [];
        var set = langOf(opts.lang);
        var starts = (opts.sentences || []).map(function (s) { return s.start; });

        function sentStartAt(i) {
            var best = 0;
            for (var k = 0; k < starts.length; k++) {
                if (starts[k] <= i) best = starts[k]; else break;
            }
            return best;
        }

        function push(s, e, rep, cls, cap) {
            if (e <= s) return;
            if (guarded(zones, s, e)) return;
            found.push({ s: s, e: e, rep: rep, cls: cls, tier: TIER[cls], cap: !!cap });
        }

        if (set) {
            if (set.wordy && set.wordy.length) {
                var probes = set.wordy.map(function (p) {
                    return [new RegExp('^(?:' + pat(p[0]) + ')$', 'iu'), p[1], p[2]];
                });
                var wre = new RegExp('(^|[^\\p{L}\\p{N}-])(?:'
                    + set.wordy.map(function (p) { return pat(p[0]); }).join('|')
                    + ')(?![\\p{L}\\p{N}-])', 'giu');
                var m;
                while ((m = wre.exec(src))) {
                    /* Группа 1 — ведущий символ (или пусто в начале строки): он захвачен
                       вместо negative-lookbehind, которого нет у старого WebKit и который
                       ронял бы весь файл. Сдвигаем начало совпадения на его длину. */
                    var lead = m[1].length, at = m.index + lead;
                    var hit = m[0].slice(lead), low = hit.toLowerCase().replace(/\s+/g, ' ');
                    var rep = null, needComma = false;
                    for (var i = 0; i < probes.length; i++) {
                        if (probes[i][0].test(low)) { rep = probes[i][1]; needComma = !!probes[i][2]; break; }
                    }
                    if (m.index === wre.lastIndex) wre.lastIndex++;
                    if (rep === null) continue;
                    var head = src.slice(sentStartAt(at), at);
                    if (needComma && /\S/.test(head) && !/[,;:—–(]\s*$/.test(head)) rep = ', ' + rep;
                    // Пробел перед запятой снимет tidy(); здесь важно только,
                    // чтобы замена реально была КОРОЧЕ — иначе это не сокращение.
                    if (rep.length >= hit.length) continue;
                    if (/^\p{Lu}/u.test(hit) && !/^,/.test(rep)) {
                        rep = rep.charAt(0).toLocaleUpperCase() + rep.slice(1);
                    }
                    push(at, at + hit.length, rep, 'wordy', false);
                }
            }
            [['filler', set.filler, fillerSpan], ['hedge', set.hedge, hedgeSpan]].forEach(function (row) {
                var cls = row[0], list = row[1], span = row[2];
                if (!list || !list.length) return;
                var re = new RegExp('(^|[^\\p{L}\\p{N}-])(?:' + list.map(pat).join('|')
                    + ')(?![\\p{L}\\p{N}-])', 'giu');
                var mm;
                while ((mm = re.exec(src))) {
                    var lead2 = mm[1].length, at2 = mm.index + lead2;   // см. пояснение выше
                    if (mm.index === re.lastIndex) re.lastIndex++;
                    /* Усилитель после отрицания — часть смысла, а не нажим: «не
                       очень интересный» ≠ «не интересный», «not very good» ≠
                       «not good». До 2026-10-03 снимался и он. */
                    if (NEGATION.test(src.slice(Math.max(0, at2 - 12), at2))) continue;
                    var st = sentStartAt(at2);
                    var sp = span(src, at2, at2 + mm[0].length - lead2, st);
                    push(sp.s, sp.e, '', cls, sp.cap);
                }
            });
        }

        /* Вставки в скобках — языконезависимы. Пропускаем те, где есть цифра:
           «(2024)», «(рис. 3)», «(150 мл)» — ссылка или величина, её потеря
           меняет содержание, а не многословие. */
        var pre = /[  ]?\([^()]{4,160}\)/g, pm;
        while ((pm = pre.exec(src))) {
            if (/\d/.test(pm[0])) continue;
            push(pm.index, pm.index + pm[0].length, '', 'aside', false);
        }

        return dedupe(found);
    }

    /** Перекрытия разрешаются в пользу дешёвого по смыслу, при равенстве — длинного. */
    function dedupe(list) {
        list.sort(function (a, b) {
            if (a.s !== b.s) return a.s - b.s;
            if (a.tier !== b.tier) return a.tier - b.tier;
            return (b.e - b.s) - (a.e - a.s);
        });
        var out = [];
        list.forEach(function (op) {
            var last = out[out.length - 1];
            if (last && op.s < last.e) {
                if (op.tier < last.tier) out[out.length - 1] = op;
                return;
            }
            out.push(op);
        });
        return out;
    }

    // ── применение ───────────────────────────────────────────────────────

    /**
     * apply(text, ops) → строка. Операции склеиваются по позициям, после чего
     * ОДИН проход убирает следы правки: сдвоенные пробелы, запятую перед
     * точкой, пробел перед знаком. Без него машинная правка узнаётся с первого
     * взгляда, и вся работа насмарку.
     */
    function apply(text, list) {
        var src = String(text || '');
        // Нет правок — нет и вмешательства: швы чистятся только там, где их
        // сделала правка, а текст автора без правок отдаётся знак в знак.
        if (!list || !list.length) return src;
        var ordered = list.slice().sort(function (a, b) { return a.s - b.s; });
        var out = '', last = 0, capNext = false;

        function chunk(str) {
            if (capNext && str) {
                var i = 0;
                while (i < str.length && !LETTER.test(str[i])) i++;
                if (i < str.length) {
                    str = str.slice(0, i) + str[i].toLocaleUpperCase() + str.slice(i + 1);
                    capNext = false;
                }
            }
            return str;
        }

        ordered.forEach(function (op) {
            if (op.s < last) return;
            out += chunk(src.slice(last, op.s));
            if (op.rep) out += chunk(op.rep);
            else if (op.cap) capNext = true;
            last = op.e;
        });
        out += chunk(src.slice(last));
        return tidy(out);
    }

    function tidy(s) {
        return String(s)
            .replace(/[ \t ]{2,}/g, ' ')
            .replace(/[ \t]+([,.;:!?…])/g, '$1')
            .replace(/([,;:])[ \t]*([,;:])/g, '$1')
            .replace(/,[ \t]*([.!?…])/g, '$1')
            .replace(/\([ \t]*\)/g, '')
            .replace(/([.!?…])[ \t]*([,;:])/g, '$1')
            .replace(/^[ \t]*[,;:][ \t]*/gm, '')
            /* Текст, скопированный с сайта, приходит со склеенными
               предложениями («слушаться!С тех пор», «говорит:- Алёнушка»).
               Пока они стояли рядом, это было видно только в исходнике; когда
               между ними выпадает фраза, склейка оказывается посреди
               результата. Пробел возвращается на место — только после строчной
               буквы или закрывающей кавычки, чтобы не тронуть «т.е.» и «3.5». */
            .replace(/([\p{Ll}»”"')])([.!?…]+)(?=\p{Lu})/gu, '$1$2 ')
            .replace(/([.!?…:])(?=[-—–][ \t ])/g, '$1 ')
            /* Порядок важен: сначала пробелы по краям строк, потом пустые строки.
               Когда уходит первое предложение абзаца, следующее начиналось с
               пробела («␣Жена уроки музыки даёт»), а абзац, ушедший целиком,
               оставлял строку из пробелов, которую `\n{3,}` уже не видел, —
               в итоге посреди текста зияли пустые абзацы (замер 2026-10-03). */
            .replace(/[ \t]+$/gm, '')
            .replace(/^[ \t]+/gm, '')
            .replace(/\n{3,}/g, '\n\n')
            .trim();
    }

    // ── счёт ─────────────────────────────────────────────────────────────

    var seg = null, segLang = null;

    /**
     * Слова считает сегментатор браузера там, где он есть: регулярка по
     * пробелам объявляет китайскую или тайскую фразу ОДНИМ словом, и лимит
     * «250 слов» для этих языков до сих пор ничего не значил. Резерв — прежняя
     * регулярка, поэтому там, где Intl.Segmenter нет, поведение не меняется.
     */
    function countWords(text, lang) {
        var s = String(text || '');
        if (!s.trim()) return 0;
        try {
            if (typeof Intl !== 'undefined' && Intl.Segmenter) {
                var key = String(lang || 'ru');
                if (!seg || segLang !== key) {
                    seg = new Intl.Segmenter(key, { granularity: 'word' });
                    segLang = key;
                }
                var n = 0;
                var it = seg.segment(s);
                for (var part of it) { if (part.isWordLike) n++; }
                return n;
            }
        } catch (e) { /* нет сегментатора — считаем регуляркой */ }
        return (s.match(/[\p{L}\p{N}][\p{L}\p{N}'’-]*/gu) || []).length;
    }

    function size(text, unit, lang) {
        return unit === 'words' ? countWords(text, lang) : String(text || '').length;
    }

    /** Есть ли для языка пословные правила — странице это нужно, чтобы честно
     *  сказать «здесь работают только скобки и выбор предложений». */
    function hasRules(lang) { return !!langOf(lang); }

    root.TSTrim = {
        ops: ops,
        apply: apply,
        tidy: tidy,
        size: size,
        countWords: countWords,
        detectLang: detectLang,
        hasRules: hasRules,
        TIER: TIER,
        _guards: guards,
        _rules: RULES,
    };
})(typeof self !== 'undefined' ? self : this);
